module.exports = {
	components: {},
	props: ['id'],
	data() {
		return {
			errors: {},
			duplicateRows: [],
			duplicatedBy: null,
			duplicatedValue: null,
			totalDuplicates: null,
			isLoading: false,
			doSkipDuplicateCheck: false,
			isSkippable: false
		}
	},
	mounted() {
		this.loadDuplicates();
	},
	methods: {
		reset()
		{
			$('#confirmationRestartModal').modal('toggle');
		},
		skipDuplicateCheck()
		{
			this.doSkipDuplicateCheck = true;
			this.onConfirm();
		},
		deleteRow(duplicate) {

			for (let i = 0; i < this.duplicateRows.length; i++) {

				if (duplicate.id === this.duplicateRows[i].id) {
					this.duplicateRows[i].deleted_row = true;
				}

			}

		},
		unDeleteRow(duplicate) {

			for (let i = 0; i < this.duplicateRows.length; i++) {

				if (duplicate.id === this.duplicateRows[i].id) {
					this.duplicateRows[i].deleted_row = false;
				}

			}

		},
		setRow(data)
		{
			let duplicateRows = data.duplicates.duplicated_rows;

			for (let i = 0; i < duplicateRows.length; i++) {
				duplicateRows[i].deleted_row = false;
			}

			this.duplicateRows = duplicateRows;
			this.totalDuplicates = data.duplicates.total_rows;
			this.duplicatedBy = data.duplicates.duplicated_by;
			this.duplicatedValue = data.duplicates.duplicated_value;
			this.isSkippable = data.duplicates.is_skippable;
		},
	}
};